//#region src/api/noop.ts
function getNoopAPI() {
	return {
		pushLog: () => {},
		pushError: () => {},
		changeStacktraceParser: () => {},
		getStacktraceParser: () => void 0,
		pushMeasurement: () => {},
		pushTraces: () => {},
		getOTEL: () => void 0,
		getTraceContext: () => void 0,
		initOTEL: () => {},
		isOTELInitialized: () => false,
		setUser: () => {},
		resetUser: () => {},
		setSession: () => {},
		resetSession: () => {},
		getSession: () => void 0,
		setView: () => {},
		getView: () => void 0,
		setPage: () => {},
		getPage: () => void 0,
		pushEvent: () => {},
		startUserAction: () => void 0,
		getActiveUserAction: () => void 0
	};
}
//#endregion
export { getNoopAPI };

//# sourceMappingURL=noop.js.map